import React from 'react';
import Styled from 'styled-components';
import Icon from '@components/Icon';
import { Button } from '@components/ButtonV2';

const Wrapper = Styled.div`
  min-height: 60vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  background-color: #E3F4FE;
  /* background-color: ${props => props.theme.colors.secondary['gray-5']}; */
`;

const Text = Styled.p`
  max-width: 500px;
  color: ${props => props.theme.colors.neutrals.black};
  font-size: 20px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  padding: 20px;
  margin: 0 0 20px 0;
`;

const VideoLockOverlay = ({ text, buttonText, hasAccess, buttonUrl }) => {
  return (
    <Wrapper>
      <Icon name="ygb-icon-infob" fontSize="30px" color="#242424" />
      <Text>{text}</Text>
      {!hasAccess ? (
        <Button appearance="default-blue" href={buttonUrl}>
          {buttonText}
        </Button>
      ) : null}
    </Wrapper>
  );
};

export default VideoLockOverlay;
